<template>
	<div class='gPageBorder'>
		<div class="source gSgLeftBtn" style="">
			<span class="wrapper">
				<span v-show='!hidest'><img @click="onClick('1')" src="../../assets/images/icon_green.png" alt="">
					{{$t('lin_global.online')}} {{nums? nums[1].nums: ''}}</span>
				<!-- <span><img @click="runClick('2')" src="../../assets/images/icon_red.png" alt=""> {{$t('lin_global.marn')}}  {{nums? nums[4].nums: ''}}</span> -->
				<span v-show='!hidest'><img @click="onClick('3')" src="../../assets/images/icon_yellow.png" alt="">
					{{$t('app_sleep')}} {{nums? nums[3].nums: ''}}</span>
				<span v-show='!hidest'><img @click="onClick('2')" src="../../assets/images/icon_gray.png" alt="">
					{{$t('lin_global.offline')}} {{nums? nums[2].nums: ''}}</span>
				<span v-show='hidest' style="margin-left: -2px;display:block;height: 20px;font-size: 16px;">
					<b>{{$t('app_devicewhe')}}</b></span>
			</span>
		</div>
		<div style="float: right;margin-top: -30px;margin-right:24px;background:none;">
			<el-row :gutter="18">
				<el-col :span="12">
					<MechanismSelector style='width:100%;' :data="mechanismData"></MechanismSelector>
				</el-col>
				<el-col :span='12'>
					<el-input :placeholder="$t('app_lkdevice')" v-model='sn' @keyup.enter.native='query' icon="search"
						:on-icon-click="query"></el-input>
				</el-col>
			</el-row>


		</div>

		<el-row class='gTopMg' v-if='isChina'>
			<el-col :span="24"> <zt-map :height="tableHeight" :mapdata1="mapdata1" :mode='0'></zt-map></el-col>
		</el-row>

		<div class='gTopMg' v-else id="gmap" style=""></div>

		<div class='gPgDiv'>
			<el-pagination style='margin-top:-1px;' class='gPg' @size-change="handleSizeChange"
				@current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[300, 500, 1000]"
				:page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalRecords">
			</el-pagination>
		</div>

	</div>
</template>


<script>
	import MechanismSelector from '@/components/global/mechanism_selector.vue'
	import ztMap from '../index/ztMap'
	import axios from 'axios'
	import {
		baseurl
	} from '../../api/url'


	import warning from '../../assets/images/icon_yellow.png'
	import online from '../../assets/images/icon_green.png'
	import offline from '../../assets/images/icon_gray.png'
	import bad from '../../assets/images/icon_yellow.png'

	export default {
		name: 'map',
		data() {
			var that = this
			return {
				sn: '',
				mechanismData: {
					placeholder: that.$t('lin_global.place_areaid'),
					callback(value) {
						that.tempMc = value
						that.mapdata1.areaid = value
						that.getData(1, value)
					}
				},
				tempMc: '',
				tableHeight: 680,
				currentPage: 1,
				totalRecords: 0,
				pageSize: 300,
				mapdata1: {
					sn: '',
					page: 1,
					rows: 300,
					status: '',
					runStatus: '',
					areaid: ''
				},
				nums: '',
			}
		},
		props: [
			'hidest'
		],
		components: {
			ztMap,
			MechanismSelector
		},
		created() {
			let bodyheight = document.documentElement.clientHeight;
			this.tableHeight = bodyheight - 150;
			this.getData(1);



			/*
			this.$terHisPath('G011746020000', (res) => {
			  console.log( res.data)

			  var ps = []
			  var p = []
			  var center = {lat: 23.5, lng: 123.3}
			  if (res.data.length > 0) {
			    var center = new window.google.maps.LatLng(res.data[0].latitude,res.data[0].longitude)
			  }
			  res.data.forEach((vl) => {
			    p.push(new window.google.maps.LatLng(vl.latitude,vl.longitude))
			    ps.push({
			      point: new window.google.maps.LatLng(vl.latitude,vl.longitude),
			      //icon: icon,
			      content: vl.locatime + '<br><br>' + vl.address,
			      //iconName: iconName,
			      width: 200
			    })
			  })
			  //console.log(center,ps,p)

			  this.initGMap(center,ps,p)
			}, (error) => {
			})*/

		},
		computed: {
			isChina() {
				// return true
				// /// 孟加拉临时版本

				if (localStorage.system_lang === 'zh_cn') {
					return true
				} else {
					return false
				}
			}
		},
		mounted() {
			//this.mapdata1.sn = 'G011746020000'
		},
		destroyed() {

		},
		methods: {
			query() {
				this.mapdata1.sn = this.sn
				this.getData(1)
			},
			initGMap(mapCenter, pointArr, pointOrg) {
				if (!window.google) {
					return
				}

				//mapCenter = {lat: 39.949227017559615, lng: 116.41707632263186}

				var map = new google.maps.Map(document.getElementById('gmap'), {
					zoom: 3,
					center: mapCenter
				});


				if (pointOrg) {
					// 折线参数
					var polylineOptions = {
						path: pointOrg,
						geodesic: true, // 可测量的
						strokeColor: "red", // 线条颜色
						strokeOpacity: 0.8, // 透明度 50%
						strokeWeight: 5 // 宽度 5像素
					};
					// 创建一个Polyline的实例
					var polyline1 = new window.google.maps.Polyline(polylineOptions);
					polyline1.setMap(map); // 设置显示到map上
					if (pointArr) {
						pointArr.forEach(function(item) {
							var mk = new google.maps.Marker({
								position: item.point,
								map: map,
								icon: item.icon
							})
							var ct = item.content
							var infowindow = new google.maps.InfoWindow({
								content: ct,
								maxWidth: 200
							});
							mk.addListener('click', function() {
								if (window.preInfoView) {
									window.preInfoView.close(map, mk)
								}
								window.preInfoView = infowindow
								infowindow.open(map, mk);
							})
						}, this);
					}
				} else {
					if (pointArr) {
						pointArr.forEach(function(item) {
							var mk = new google.maps.Marker({
								position: item.point,
								map: map,
								icon: item.icon
							})
							if (item.iconName === 'online') {
								//mk.setAnimation(window.google.maps.Animation.BOUNCE);
							} else {
								//mk.setAnimation(null)
							}

							var ct = item.content
							var infowindow = new google.maps.InfoWindow({
								content: ct,
								maxWidth: 200
							});
							mk.addListener('click', function() {
								if (window.preInfoView) {
									window.preInfoView.close(map, mk)
								}
								window.preInfoView = infowindow
								infowindow.open(map, mk);
							})
						}, this);
					}
				}

			},
			getNums: function() {

				var tno = this.sn ? this.sn : ''
				var mech = this.tempMc ? this.tempMc : ''

				var params = {
					page: 0,
					rows: 0,
					areaid: mech,
					terminal_no: tno
				};
				axios.post(`${baseurl}/terminal/statusCount.do`, params).then(res => {
					if (res.data.status == 200) {
						this.nums = res.data.data;

					} else {

					}

				}).catch(function(error) {

				})

			},
			onClick: function(val) {
				this.mapdata1.areaid = this.tempMc
				this.mapdata1.runStatus = '';
				this.mapdata1.status = val;
				this.getData(1);

			},
			runClick: function(val) {
				this.mapdata1.runStatus = val;
				this.mapdata1.status = '';
				this.getData(1);
			},
			handleSizeChange: function(val) {
				this.pageSize = val;
				this.mapdata1.rows = val;

				//this.getData(this.currentPage,'','','','')
				//console.log(`每页 ${val} 条`)
			},
			handleCurrentChange: function(val) {

				this.currentPage = val;
				//this.getData(val)
				//this.mapdata1.page = val;
				this.mapdata1.sss = 'abc'
				this.mapdata1.page = val
				if (!this.isChina) {
					this.getData(val)
				}
				//this.getData(this.currentPage,'','','','')
				//console.log('当前页: ${val}')
			},
			getData(page) {
				this.getNums()
				var _this = this
				this.currentPage = page;
				var tno = this.sn ? this.sn : ''
				var mech = this.tempMc ? this.tempMc : ''
				var params = {
					page: page,
					rows: this.pageSize,
					areaid: mech,
					terminal_no: tno,
					terminal_status: this.mapdata1.status,
					terminal_runtime_status: this.mapdata1.runStatus
				}
				axios.post(`${baseurl}/terminal/list.do`, params).then(res => {

					var ps = []
					if (res.data.status == 200) {
						this.totalRecords = res.data.total;
						var arr = res.data.data

						if (arr) {
							if (arr.length > 0) {

								arr.forEach((vl) => {
									var tst = ''
									var tRst = ''
									var icon = ''
									var iconName = ''
									if (vl.terminalStatus === '1') {
										tst = this.$t('app_online')
										icon = online
										iconName = 'online'

									} else if (vl.terminalStatus === '2') {
										tst = this.$t('app_offline')
										icon = offline
										iconName = 'offline'

									} else if (vl.terminalStatus === '0') {
										tst = this.$t('app_new')
										icon = offline
										iconName = 'offline'
									} else if (vl.terminalStatus === '3') {

										tst = this.$t('app_sleep')
										icon = warning
										iconName = 'warning'
									}

									/*if (vl.runTimeStatus === '1') {
									  tRst = this.$t('lin_global.fault')
									  icon = bad
									  iconName = 'bad'
									} else if (vl.runTimeStatus === '2') {
									  tRst = this.$t('lin_global.marn')
									  icon = warning,
									  iconName = 'warning'
									} else if (vl.runTimeStatus === '3') {
									  tRst = this.$t('app_sleep')
									  icon = warning,
									  iconName = 'warning'
									}  else {
									  tRst = this.$t('lin_global.normal')
									  icon = icon
									  iconName = iconName
									} */


									var text = '<span style="line-height:20px;font-size:14px;">' + _this
										.$t('lin_global.label_no') + '：' + vl.terminalNo + '<br>' + _this
										.$t('lin_global.label_name') + '：' + vl.terminalName + '<br>' +
										_this.$t('lin_global.label_areaid_name') + '：' + vl.mechName +
										'<br>' + _this.$t('lin_global.label_address') + '：' + vl
										.currentAddress + '<br>' + _this.$t('lin_global.wlzt') + '：' +
										tst + '</br>' + '<br><a href="' + './#/terList/' + vl.terminalId +
										'/details" style="float:right;">' + _this.$t('lin_global.ckxq') +
										'</a></span>'

									// var text = '<span style="line-height:20px;font-size:14px;">'+_this.$t('lin_global.label_no')+'：' + vl.terminalNo + '<br>'+_this.$t('lin_global.label_name')+'：' + vl.terminalName + '<br>'+_this.$t('lin_global.label_areaid_name')+'：' + vl.mechName + '<br>'+_this.$t('lin_global.label_address')+'：' + vl.currentAddress + '<br>'+_this.$t('lin_global.wlzt')+'：' + tst + '</br>'+_this.$t('lin_global.run_status')+'：' + tRst + '<br><a href="/#/terList/' + vl.terminalId + '/details" style="float:right;">'+_this.$t('lin_global.ckxq')+'</a></span>'



									var cor = vl.coordinate.split(',')
									var lat = ''
									var lng = ''
									if (cor.length > 0) {
										lng = parseFloat(cor[0])
										lat = parseFloat(cor[1])
									}
									ps.push({
										point: {
											lat: lat,
											lng: lng
										},
										icon: icon,
										content: text,
										iconName: iconName,
										width: 200
									})

								})

							}
						}
					} else {
						ps = ''
					}
					//console.log(ps)


					if (this.isChina) {

					} else {
						//console.log(ps, p)
						var center = {
							lat: 23.5,
							lng: 123.3
						}
						if (ps.length > 0 && this.sn) {
							center = ps[0].point
						}
						window.onload = () => {
							this.initGMap(center, ps)
						}
						this.initGMap(center, ps)
					}


				}).catch(function(error) {

				})

			}

		}
	}
</script>
<style scoped>
	/* google css */
	#gmap {
		height: 680px;
		width: 100%;
	}

	/* */

	.wrapper span {
		display: inline-block;
		margin: 0 10px;
		font-size: 12px;
		vertical-align: middle;
	}

	.wrapper span img {
		display: inline-block;
		vertical-align: middle;
		cursor: pointer;
	}
</style>


// WEBPACK FOOTER //
// map.vue?6b448019